export default __webpack_public_path__ + "static/media/h.c123e88f.png";